<template>
    <!--
        The design's reset request: the same card as the login. What the API answers is
        unchanged; the answer is shown in the card instead of a toast - the sent state
        replaces the form, a refusal shows above the field.
    -->
    <div class="auth">
        <div class="auth-card">
            <template v-if="isSent">
                <div class="auth-done-icon"><span class="mdi mdi-check" aria-hidden="true"></span></div>
                <div class="auth-head">
                    <h1 class="auth-title">{{ $lang.Member.ResetSentTitle }}</h1>
                    <p class="auth-subtitle">{{ $lang.Member.ResetSentBodyA }}<b>{{ email }}</b>{{ $lang.Member.ResetSentBodyB }}</p>
                </div>
                <p class="auth-note">{{ $lang.Member.ResetSentHint }}</p>
                <div class="auth-actions">
                    <b-button type="is-primary" expanded @click="backToLogin()">{{ $lang.Member.BackToLogin }}</b-button>
                    <b-button class="auth-secondary" expanded @click="isSent = false">{{ $lang.Member.ResendLink }}</b-button>
                </div>
            </template>

            <template v-else>
                <div class="auth-head">
                    <h1 class="auth-title">{{ $lang.Login.ForgetPassword }}</h1>
                    <p class="auth-subtitle">{{ $lang.Member.ResetSubtitle }}</p>
                </div>

                <div v-if="isFailed" class="auth-error">{{ $lang.Member.ResetFailedMsg }}</div>

                <b-field :label="$lang.Login.EmailLabel" :type="{ 'is-danger': hasError_email || isFailed }" :message="emptyWarning_email || $lang.Member.ResetFieldHint">
                    <b-input v-model="email" type="email" :maxlength="limits.emailAddress" :has-counter="false" placeholder="ad@firma.com"></b-input>
                </b-field>

                <div class="auth-actions">
                    <b-button class="auth-submit" type="is-primary" expanded @click="sendEmail()">{{ $lang.Member.Password_Email }}</b-button>
                    <b-button class="auth-text" expanded @click="backToLogin()">{{ $lang.Member.BackToLogin }}</b-button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';
    import { LIMITS } from '@/constants/registration';

    export default {
        name: 'PasswordEmail',
        data() {
            return {
                // The CRM's e-mail limit, as at registration. This was 30, so members with a
                // longer address could not ask for a reset at all.
                limits: LIMITS,
                isActive: true,
                email: '',
                hasError_email: false,
                emptyWarning_email: '',
                isSent: false,
                isFailed: false
            }
        },
        mounted() {
            this.$store.state.isFooterFixed = true;
        },
        methods: {
            sendEmail() {
                api.members.sendResetPasswordEmail(this.email).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    } else {
                        this.isSent = !!res.data;
                        this.isFailed = !res.data;
                    }
                });
            },
            backToLogin() {
                router.push('/LoginMember');
            }
        }
    };
</script>
